<template>
    <div class="help-page">
        <tabbed-view :default-tab-id="$hisport.options.platform.help.pages[0].key">
            <tab v-for="item in $hisport.options.platform.help.pages" :key="item.key" :id="item.key" :title-i18n="item.title">
                <iframe :src="item.src" style="width:100%;height:calc(100vh - 95px)"/>
            </tab>
        </tabbed-view>
    </div>
</template>
<script>
import tabbedView           from "./_components/tabbed_view";
import tab                  from "./_components/tab";
export default {
    title: "MN_HELP",
    components:{
        tabbedView,
        tab
    }
}
</script>
<style scoped>
</style>